import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralStatusIA = function BrandReferralStatusIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_STATUS_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_STATUS_TITLE = function BRAND_REFERRALS_STATUS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "MBTd1t",
    defaultMessage: [{
      "type": 0,
      "value": "How to check the status of brand referrals"
    }]
  });
};
var BRAND_REFERRALS_STATUS_DESCRIPTION = function BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "HhHXze",
    defaultMessage: [{
      "type": 0,
      "value": "Go to \"Refer brands\" in \"Account\", and select the \"Invited\" tab to check the status of a brand’s application. Note that we can only share additional details about a brand’s application directly with the brand itself."
    }]
  });
};